import { Router, RouteRecordRaw, createRouter, createWebHistory } from "vue-router";
import Index from "@/views/Index.vue";
import PageNotFound from "@/views/errors/PageNotFound.vue";

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        name: "ComputerInfor",
        component: Index,
        meta: {
            title: "ComputerInfor",
        },
    },
    {
        path: "/:catchAll(.*)",
        name: "PageNotFound",
        component: PageNotFound,
        meta: {
            title: "Page Not Found",
            hideInNavigator: true,
            hideInSitemap: true,
        },
    },
];

const router: Router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.afterEach((to) => {
    if (to.meta.title == null) {
        document.title = "ComputerInfor";
    } else {
        let appendix: string;

        if (to.fullPath == "/") {
            appendix = "";
        } else {
            appendix = " | ComputerInfor";
        }

        document.title = to.meta.title as string + appendix;
    }
});

export default router;
